module.exports = __webpack_public_path__ + "img/20210703_113649.d7552afe.jpg";